import React, { useEffect, useMemo, useState } from "react";
import * as image from "../../resources/images";
import { getCapitalized, getSequnceSort, replaceName } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getPlanUserCourse, getSctReflectionData, sctReflectionResponse } from "../../redux/actions/APIs";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import ReflectionImage from "./ReflectionImage";
const SctModule = ({ getMyActivity, takeAChallenge, selectedOPtion, setSelectedOPtion }) => {
    const params = useParams();
    const location = useLocation();
    const dispatch = useDispatch();

    const {
        defaultChildData,
        loggedInUser,
        sctData,
        sctReflectionResp,
    } = useSelector((state) => state.collections);

    const [showReflection, setShowReflection] = useState("");
    const [boosterData, setBoosterData] = useState("");
   

    const sctStaticImage = [image.solar_chat, image.solar_express, image.solar_confounded];
    const boosterStaticImage = [image.starvector, image.solar_skip, image.solar_sleeping, image.solar_verified];

   useEffect(()=>{
        dispatch(sctReflectionResponse());
   }, [])

    // useEffect(() => {
    //     if (defaultChildData?.id) {
    //             dispatch(getSctReflectionData(defaultChildData?.id, params?.courseId, params?.activityId));
    //     }
    // }, [defaultChildData])


    useEffect(()=>{
        if(getMyActivity && !sctReflectionResp){
            hadnleMyReflection("", getMyActivity?.followUp);
        }
    },[getMyActivity])


     const hadnleMyReflection = (type , option) => {
        let getData = sctReflectionResp?.records?.length > 0 ? sctReflectionResp?.records[0] : {};
            if(option?.followUpType === "Reflection"){
                setShowReflection(type);
            }else if(option?.followUpType === null){
                setShowReflection(sctReflectionResp?.objectName === "Reflection" ? type : "booster1");
            }else{
                setShowReflection("");
            }
            // console.log("hadnleMyReflection inn ", getData, option);
            setSelectedOPtion(option);
            let body = {
                    "questionId": getData?.id,
                    "title": getData?.title ,
                    "learnerId": defaultChildData?.id,
                    "userId": loggedInUser?.id,
                    "optionId": option?.id,
                    "followUpId": option?.followUpId,
                    "followUpType": option?.followUpType,
                    "courseId": params?.courseId,
                    "activityId": params?.activityId,
                    "optionSequence": option?.sequence,
                }
            dispatch(sctReflectionResponse(body));  
    }
    // console.log("hadnleMyReflection out", sctReflectionResp);
    useEffect(()=>{
        if(sctReflectionResp?.records?.length > 0){
            let refData = sctReflectionResp?.records[0];
            if(refData?.id){
                setBoosterData(refData);
            }else{
                setBoosterData("");
            }
            // else{
            //     if(sctReflectionResp?.objectName === "Booster"){
            //         setShowReflection("booster1");
            //     }else {
            //         const refType = setSelectedOPtion?.sequence == 0 ? "excellent" : setSelectedOPtion?.sequence == 1 ? "good" : "poor";
            //         setShowReflection(refType);
            //     }
                
            // }
            
        }
    },[sctReflectionResp])
   
    const handleSctNext = ()=>{
        setShowReflection("");
        setSelectedOPtion("");
    }
    // console.log("sctReflectionResp  : ", getMyActivity, sctReflectionResp, boosterData);
    return (
        <div className="sctmodules">
            {!showReflection && !boosterData && false && (
                <>
                    <div class="knowledgechecknavigation">
                    </div>
                    <h3 className="h-3 fw-600 mt-2  mb-4">{sctData?.records[0]?.question}</h3>
                    <div class="message_box mw-100">
                        <p className="quoteicons"><img src={image.Vector_quote} alt="quote"></img></p>
                        <p class="mt-3">
                            <span>
                                <p>
                                    {
                                        sctData?.records?.length > 0 && 
                                        sctData?.records[0]?.prompt
                                    }
                                    Have you noticed when your focus drifts and found ways to handle distractions better?
                                </p>
                            </span>
                        </p>
                    </div>
                    <div className="sctmessagelist pointer">
                        <ul>
                            {sctData?.records?.length > 0 && 
                                getSequnceSort(sctData?.records[0]?.options)?.map((option, index)=>{
                                    const refType = index == 0 ? "excellent" : index == 1 ? "good" : "poor";
                                    return(
                                        <li 
                                        // onClick={() => {option?.booster ? hadnleReflection("", option?.booster) : hadnleReflection("good", "")}}
                                        onClick={()=>hadnleMyReflection(refType, option)}
                                     >
                                        <p className="flextwo"> 
                                            <img src={sctStaticImage[index]} className="mr-3" />
                                        {option?.answer}</p>
                                    </li>
                                    ) 
                                })
                            }
                        </ul>
                    </div>
                </>
            )}
            {showReflection && sctReflectionResp && (sctReflectionResp?.records[0]?.title === "Reflection" || !sctReflectionResp?.records[0]?.id) ? (
                <ReflectionImage 
                    showReflection={showReflection} 
                    selectedOPtion={selectedOPtion}
                />
            ) : boosterData && (
                <>
                    <h3 className="h-3 fw-600 mt-2  mb-4">{replaceName(loggedInUser, boosterData?.question)}</h3>
                    <div class="message_box mw-100">
                        <p className="quoteicons"><img src={image.Vector_quote} alt="quote"></img></p>
                        <p class="mt-3">

                            <p className="mb-3">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            `${boosterData?.prompt && replaceName(loggedInUser, boosterData?.prompt)}`,
                                    }}
                            />
                            
                            </p>
                            {/* <ul>
                                <li className="mb-2 text-left">
                                    <p className="p2 "><span>1. </span>Pick one short task (like 10 minutes of reading, drawing, or homework).</p>
                                </li>
                                <li className="mb-2 text-left">
                                    <p className="p2 "><span>2. </span>Before you start, write down how focused you feel (1 = not focused at all, 5 = super focused).</p>
                                </li>
                                <li className="mb-2 text-left">
                                    <p className="p2 "><span>3. </span>After you finish, rate it again. What changed? Did anything distract you?</p>
                                </li>
                            </ul> */}
                        </p>
                        {/* <p>This helps you notice your patterns—and that’s the first step to improving them. Tell {getCapitalized(loggedInUser?.parent?.firstName)} what you discovered!</p> */}
                    </div>
                    <div className="sctmessagelist pointer">
                        <ul>
                            {boosterData && 
                                getSequnceSort(boosterData?.options)?.map((option, index)=>{
                                    const refType = index % 2 == 0 ? "booster1" : "booster1";
                                    return(
                                        <li 
                                            onClick={()=>hadnleMyReflection(refType, option)}
                                        >
                                            <p className="flextwo"> 
                                                <img src={boosterStaticImage[index]} className="mr-3" />
                                                {replaceName(loggedInUser, option?.answer)}
                                            </p>
                                    </li>
                                    ) 
                                })
                            }
                        </ul>
                    </div>
                </>
            ) }

            {showReflection && sctReflectionResp?.records  && (
                 <div className="next_prevlist w-100 text-right mt-3">
                    <div className="flexone">
                        <a href="javascript:void(0)">
                                {/* <i class="fa-regular fa-arrow-left mr-2"></i> Previous */}
                        </a>{""}
                        <a
                            href="javascript:void(0)"
                            onClick={() =>{sctReflectionResp?.records?.length > 0 && sctReflectionResp?.records[0]?.id ? handleSctNext()  : takeAChallenge("Challenges")}}
                        >
                            {sctReflectionResp?.records?.length > 0 && sctReflectionResp?.records[0]?.id ? "Next" : "Take a Challenge"}
                            <span>
                                <i class="fa-regular fa-arrow-right ml-2"></i>
                            </span>

                        </a>

                    </div>
                </div>
            )}

        </div>
    );
}
export default SctModule;